import { render, staticRenderFns } from "./AccountData.vue?vue&type=template&id=f12e03d6&scoped=true&lang=html"
import script from "./AccountData.vue?vue&type=script&lang=js"
export * from "./AccountData.vue?vue&type=script&lang=js"
import style0 from "./AccountData.vue?vue&type=style&index=0&id=f12e03d6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f12e03d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/html/untrrv2/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f12e03d6')) {
      api.createRecord('f12e03d6', component.options)
    } else {
      api.reload('f12e03d6', component.options)
    }
    module.hot.accept("./AccountData.vue?vue&type=template&id=f12e03d6&scoped=true&lang=html", function () {
      api.rerender('f12e03d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/account/AccountData.vue"
export default component.exports